const cdnBase = document.querySelector('meta[name="cdn-base-url"]')?.content?.replace(/\/$/, '') ?? '';

function loadAnalytics() {
    if (window._gaLoaded) return;
    window._gaLoaded = true;

    window.dataLayer = window.dataLayer || [];
    if (typeof gtag !== 'function') {
        window.gtag = function () {
            dataLayer.push(arguments);
        };
    }

    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-5E1NFBZH51';
    script.async = true;
    script.onload = () => {
        const config = document.createElement('script');
        config.src = `${cdnBase}/assets/js/google-analytics.min.js`;
        config.async = true;
        document.body.appendChild(config);
    };
    document.head.appendChild(script);
}

document.addEventListener('DOMContentLoaded', () => {
    const path = window.location.pathname;
    const isQrPage = path.startsWith("/qr");
    const isPrivacyPage = path === '/privacy' || path === '/privacy-policy';
    // Suppress only the *automatic first-visit prompt* on QR/privacy pages — the
    // banner, buttons, and "manage preferences" trigger (e.g. in the footer, present
    // on every page) must still work everywhere if a visitor asks for them directly.
    const suppressAutoPrompt = isQrPage || isPrivacyPage;

    const banner = document.getElementById('cookie-banner');
    const acceptBtn = document.getElementById('accept-cookies');
    const declineBtn = document.getElementById('decline-cookies');

    let consent = localStorage.getItem('cookieConsent');
    const consentDate = localStorage.getItem('cookieConsentDate');

    // Re-prompt after 6 months if declined
    if (consent === 'declined' && consentDate) {
        const daysSince = (Date.now() - new Date(consentDate)) / (1000 * 60 * 60 * 24);
        if (daysSince >= 180) {
            localStorage.removeItem('cookieConsent');
            localStorage.removeItem('cookieConsentDate');
            consent = null;
        }
    }

    function acceptConsent() {
        localStorage.setItem('cookieConsent', 'accepted');
        localStorage.setItem('cookieConsentDate', new Date().toISOString());
        banner?.classList.add('hidden');
        loadAnalytics();
    }

    if (consent === 'accepted') {
        loadAnalytics();
    }

    if (!consent && !suppressAutoPrompt) {
        banner?.classList.remove('hidden');
    }

    acceptBtn?.addEventListener('click', acceptConsent);

    declineBtn?.addEventListener('click', () => {
        localStorage.setItem('cookieConsent', 'declined');
        localStorage.setItem('cookieConsentDate', new Date().toISOString());
        banner?.classList.add('hidden');
    });

    // Any element with this class (e.g. "Manage cookie preferences" on the Cookie
    // Policy page, or in the footer on every page) re-opens the banner so a visitor
    // can change an earlier choice — no inline script needed, CSP-safe by construction.
    document.querySelectorAll('.cookie-preferences-trigger').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            banner?.classList.remove('hidden');
            banner?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    });
});
